import { store } from "../store/index";
import {
  userLogout,
  getProfile,
  loginExt,
  setAuthToken,
  setAuthUser,
  updatePassword,
  getAllUsers,
  createUser,
  getUser,
  getAllSpeakers,
} from "../store/actions/AuthActions";

export const profile = async () => {
  const result = await store.dispatch(getProfile());
  if (result?.payload?.data) {
    return result.payload.data;
  }

  return null;
};

export const logout = async () => {
  await store.dispatch(userLogout());

  return null;
};

export const login = async (user, password) => {
  const obj = {
    email: user,
    password,
  };
  const result = await store.dispatch(loginExt(obj));
  if (result?.payload?.access_token) {
    await store.dispatch(setAuthUser(result.payload.user));
    await store.dispatch(
      setAuthToken({
        access_token: result.payload.access_token,
        token_expiration: result.payload.token_expiration,
      })
    );
    return result.payload.user.changePass ? "CHANGE" : "OK";
  } else if (result?.payload?.data) {
    return result.payload.data;
  }

  return null;
};

/**
 * Update password
 */
export const changePassword = async (values) => {
  const objSend = {
    password: values.password,
  };

  const result = await store.dispatch(updatePassword(objSend));
  if (result && result.payload) {
    return "OK";
  }
  return null;
};

export const listUsers = async (filter) => {
  const result = await store.dispatch(getAllUsers(filter));
  if (result?.payload?.data) {
    return result.payload.data;
  }
  return null;
};

export const addUser = async (values) => {
  const objSend = { ...values };
  const result = await store.dispatch(createUser(objSend));
  if (result?.payload?.data?.uuid) {
    return "OK";
  }
  return null;
};


export const getUserByUuid = async (uuid) => {
  const param = [uuid];
  const result = await store.dispatch(getUser(param));
  if (result?.payload?.data) {
    return result.payload.data;
  }
  return null;
};

export const listSpeakers = async (filter) => {
  const result = await store.dispatch(getAllSpeakers(filter));
  if (result?.payload?.data) {
    return result.payload.data;
  }
  return null;
};